<app-basic-page [pageTitle]="'Assignments'">
  <app-primary-button
    class="header-right start-new-call"
    [icon]="'add'"
    [text]="'Add Assignment'"
    (click)="onAddLeaderBoardClick()"
  ></app-primary-button>

  @if (paidStatus()?.type !== StripeProductType.premium) {
    <app-upgrade-to-premium> </app-upgrade-to-premium>
  } @else {
    <nz-tabset [(nzSelectedIndex)]="selectedTabIndex">
      <nz-tab nzTitle="Completion Report">
        <div class="tab-content vertical-large">
          @if (isLoadingTaskList()) {
            <nz-skeleton [nzActive]="true"></nz-skeleton>
          } @else {
            @for (task of taskList(); track $index) {
              <app-scenario-task-card
                [mode]="'completionReport'"
                [task]="task"
                [boardIdList]="boardIdList()"
              ></app-scenario-task-card>
            }
          }
        </div>
      </nz-tab>
      <nz-tab nzTitle="Grading Report">
        <div class="tab-content vertical-large">
          @if (isLoadingTaskList()) {
            <nz-skeleton [nzActive]="true"></nz-skeleton>
          } @else {
            @for (task of taskList(); track $index) {
              <app-scenario-task-card
                [task]="task"
                [boardIdList]="boardIdList()"
                [mode]="'gradingReport'"
              ></app-scenario-task-card>
            }
          }
        </div>
      </nz-tab>
    </nz-tabset>
  }
</app-basic-page>

<app-new-scenario-task [(isVisible)]="isAddScenarioTaskVisible"></app-new-scenario-task>
